import React from 'react'


const EditEventFormPrintInput = ({elementId, eventData, form_settings}) => {
    const headline= form_settings.element_types.items[elementId].label
    const arrayOfIds= form_settings.element_types.items[elementId].input_types

    if(0 === arrayOfIds.length)  {
        return ''
    }

    return (
        <div className="margin-bottom-double">
            <p className="margin-bottom-half text-regular">{headline}</p>
            <ul>
                {arrayOfIds.map(inputId => {
                    const label = form_settings.input_types.items[inputId].form_layout_field_label
                    const value = eventData.input_types[inputId]

                    if(!value) {
                        return ''
                    }

                    return(
                        <li key={inputId} className="container-3">
                            <span className="text-small-light">{label + ': '}</span>
                            <span className="text-small-light">{value}</span>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default EditEventFormPrintInput